import { StandardProps } from "../componentMap";

export type OptionsType = {
  isSelected: boolean;
  url: string;
  name: string;
  selectorTitle: string;
  selectorValue: string;
}[];

type ScreenSize = {
  size: string;
  url: string;
};

type ProductRange = Array<{
  pimId: string;
  sku: string;
  screenSizes: ScreenSize[];
  selectorTitle: string;
  selectorValue: string;
}>;

export function getOptionsList(
  product: StandardProps["product"],
  productsRange: Record<string, ProductRange>,
  sellingProductTypes: string[],
): OptionsType {
  const pimId: string = product?.aliases?.pimProductId;
  const sellingProductType = product?.sellingProductType;
  if (
    !sellingProductType ||
    !sellingProductTypes.includes(sellingProductType)
  ) {
    return [];
  }

  const foundProduct = productsRange[sellingProductType]?.find(
    (item) => item?.pimId === pimId,
  );

  if (!foundProduct) {
    return [];
  }

  const screenSizeAttribute = product?.attributes?.find(
    (attr) => attr.key === "screensize",
  );

  return foundProduct.screenSizes.map((s) => ({
    isSelected:
      screenSizeAttribute?.values.some(
        (val) => parseFloat(val) === parseFloat(s.size),
      ) ?? false,
    url: s.url,
    name: String(s.size),
    selectorTitle: foundProduct.selectorTitle,
    selectorValue: s.size,
  }));
}
